import React, { useEffect } from 'react';
import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import { ButtonContainer, StyledButton } from './Styles';

const ZoomButton = () => {
  const {
    BidStore: { auction: { zoomLevel } },
    UIStore: { handleZoomLevel },
  } = useStores();

  const onZoom = () => {
    if (zoomLevel < 1) {
      handleZoomLevel(1.0);
      return;
    }
    handleZoomLevel(0.67);
  };

  useEffect(() => {
    document.body.style.zoom = zoomLevel;
    document.body.blur();
  }, [zoomLevel]);

  return (
    <ButtonContainer>
      <StyledButton onClick={onZoom} title="NOTE: If display is 1024 x 768, you must use a Chrome browser for this to work. Firefox does not work!">
        <i className={`fa ${zoomLevel < 1 ? 'fa-search-plus' : 'fa-search-minus'} fa-2`} aria-hidden="true" />
        {zoomLevel < 1 ? 'ZOOM IN' : 'ZOOM OUT'}
      </StyledButton>
    </ButtonContainer>
  );
};

export default observer(ZoomButton);
